(function(utils) {
	utils.kaoBroj = function(sto, bKaoBroj, iDuljina){
		if ((bKaoBroj) && (sto != '')){
			return sto.padStart(iDuljina, " ");  
		}else{
			return sto;
		}
	};
} (konto.os.utils = {}));